import { render } from "./Imprint.vue?vue&type=template&id=14a3ba3c&bindings={\"questionsConfig\":\"options\"}"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"
script.render = render

export default script